import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TEuDdpStore,
	TEuDdpOrderStatusesResponseData,
	TEuDdpOrderIdResponsePayload,
	TEuDdpOrderResponsePayload,
	TEuDdpRequestShipmentResponseData,
	TEuDdpDeliveryOperatorsResponseData,
	TEuDdpS10ResponseData,
} from './types';

// ==========================================:
const getEuDdpState = (state: TStoreState): TEuDdpStore => state.euDdp;
export const getEuDdp = getEuDdpState;

// ====================================================:

export const getEuDdpOrders = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): TEuDdpOrderResponsePayload => euDdp.euDdpOrders,
);

// ====================================================:

export const getEuDdpOrdersIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpOrdersLoading,
);

// ====================================================:

export const getEuDdpOrder = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): TEuDdpOrderIdResponsePayload => euDdp.euDdpOrder,
);

// ====================================================:

export const getEuDdpOrderIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpOrderLoading,
);

// ====================================================:

export const getEuDdpOrderError = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): string | null => euDdp.euDdpOrderError,
);

// ====================================================:

export const getEuDdpOrderStatuses = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): TEuDdpOrderStatusesResponseData => euDdp.euDdpOrderStatuses,
);

// ====================================================:

export const getEuDdpOrderStatusesIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpOrderStatusesLoading,
);

// ====================================================:

export const getEuDdpRequestShipmentIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpRequestShipmentLoading,
);

// ====================================================:

export const getEuDdpRequestShipmentError = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): string | null => euDdp.euDdpRequestShipmentError,
);

// ====================================================:

export const getEuDdpRequestShipmentData = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): TEuDdpRequestShipmentResponseData => euDdp.euDdpRequestShipmentData,
);

// ====================================================:

export const getEuDdpConfirmShipmentIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpConfirmShipmentLoading,
);

// ====================================================:

export const getEuDdpConfirmShipmentError = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): string | null => euDdp.euDdpConfirmShipmentError,
);

// ====================================================:

export const getEuDdpUpdateWeightIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpUpdateWeightLoading,
);

// ====================================================:

export const getEuDdpUpdateWeightError = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): { productId: string; ts: number } | null => euDdp.euDdpUpdateWeightError,
);

// ====================================================:

export const getEuDdpUpdateDescriptionIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpUpdateDescriptionLoading,
);

// ====================================================:

export const getEuDdpUpdateHs6CodeIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpUpdateHs6CodeLoading,
);

// ====================================================:

export const getEuDdpUpdateOrderFieldValueIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpUpdateOrderFieldValueLoading,
);

// ====================================================:

export const getEuDdpProformaInvoiceIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpProformaInvoiceLoading,
);

// ====================================================:

export const getEuDdpProformaInvoiceUploadIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpProformaInvoiceUploadLoading,
);

// ====================================================:

export const getEuDdpSignedProformaInvoiceIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpSignedProformaInvoiceLoading,
);

// ====================================================:

export const getEuDdpLabelIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpLabelLoading,
);

// ====================================================:

export const getEuDdpDeliveryOperators = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): TEuDdpDeliveryOperatorsResponseData => euDdp.euDdpDeliveryOperators,
);

// ====================================================:

export const getEuDdpDeliveryOperatorsIsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpDeliveryOperatorsLoading,
);

// ====================================================:

export const getEuDdpS10Data = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): TEuDdpS10ResponseData => euDdp.euDdpS10Data,
);

// ====================================================:

export const getEuDdpS10IsLoad = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): boolean => euDdp.euDdpS10Loading,
);

// ====================================================:

export const getEuDdpS10Error = createSelector(
	[getEuDdp],
	(euDdp: TEuDdpStore): string | null => euDdp.euDdpS10Error,
);
